import React, { useEffect, useState } from "react";
import GrayCard from "components/gray-card";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import styled from "styled-components";
import Radio from "components/radio";
import DateInput from "components/inputs/date-input";

interface IProps {
  preorderDate?: Date | null;
  setPreorderDate: (date: Date | null) => void;
}
const Preorder = ({ preorderDate, setPreorderDate }: IProps) => {
  const [preorder, setPreorder] = useState(false);
  const [date, setDate] = useState<Date | null>(preorderDate || new Date());

  useEffect(() => {
    setPreorderDate(date);
  }, [date]);

  return (
    <GrayCard title="Preorder " subtitle="(iTunes & Amazon)">
      <Typography weight="medium" color={Colors.grey400} mb="1.6">
        Has this release been released before?
      </Typography>
      <RadioItems>
        <RadioItem>
          <Radio value={!preorder} onClick={() => setPreorder(false)} />
          <Typography color={Colors.white200} ml="0.4">
            No, don’t let anyone buy it until the release date
          </Typography>
        </RadioItem>
        <RadioItem>
          <Radio value={preorder} onClick={() => setPreorder(true)} />
          <Typography color={Colors.white200} ml="0.4">
            Yes let people preorder before the release date
          </Typography>
        </RadioItem>
      </RadioItems>
      {preorder && (
        <DateInputItem>
          <DateInput
            label="Preorder start date"
            initialDate={date}
            minDate={new Date()}
            selectDate={(date) => setDate(date)}
          />
        </DateInputItem>
      )}
    </GrayCard>
  );
};

export default Preorder;

const RadioItems = styled.div`
  justify-content: space-between;
`;

const RadioItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 2.4rem;
`;

const DateInputItem = styled.div`
  width: 24rem;
`;
